import { forwardRef, useState, useRef, useCallback, useEffect } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import cn from 'classnames';
import Button from '@ebsco-ui/button';
import { jsxs, jsx } from 'react/jsx-runtime';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

var MoreInfo = forwardRef(function (_ref, ref) {
  var label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      collapseButtonContent = _ref.collapseButtonContent,
      expandButtonContent = _ref.expandButtonContent,
      _ref$lineLimit = _ref.lineLimit,
      lineLimit = _ref$lineLimit === void 0 ? 7 : _ref$lineLimit,
      children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isButtonVisible = _useState2[0],
      setIsButtonVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isExpanded = _useState4[0],
      setIsExpanded = _useState4[1];

  var infoElementRef = useRef(null);
  var lineHeightElementRef = useRef(null);
  var infoElementRefCallback = useCallback(function (node) {
    if (ref) {
      if (typeof ref === "function") {
        ref(node);
      } else {
        ref.current = node;
      }
    }

    infoElementRef.current = node;
  }, [ref]);

  var handleClick = function handleClick() {
    setIsExpanded(!isExpanded);
  };

  var lineHeight = lineHeightElementRef.current ? lineHeightElementRef.current.offsetHeight : 0;
  var truncatedHeight = lineLimit * lineHeight;
  var checkShouldShowButton = useCallback(function () {
    var scrollheight = infoElementRef.current ? infoElementRef.current.scrollHeight : 0;
    var isTruncated = scrollheight > truncatedHeight + lineLimit;

    if (isTruncated && !isButtonVisible) {
      setIsButtonVisible(true);
      return;
    }

    if (!isTruncated && isButtonVisible) {
      setIsButtonVisible(false);
      setIsExpanded(false);
    }
  }, [infoElementRef, truncatedHeight, lineLimit, isButtonVisible]);
  useEffect(function () {
    checkShouldShowButton();
    window.addEventListener("resize", checkShouldShowButton);
    return function () {
      return window.removeEventListener("resize", checkShouldShowButton);
    };
  }, [checkShouldShowButton]);
  var getBlocksWith = createBemBlockBuilder(["eb-more-info", className]);
  var infoClassNames = cn(getBlocksWith("__info"), getBlocksWith("__info--".concat(isExpanded ? "more" : "less")));
  var infoElementHeight = isExpanded || !isButtonVisible ? {
    maxHeight: "none"
  } : {
    maxHeight: "".concat(truncatedHeight, "px")
  };
  return /*#__PURE__*/jsxs("div", {
    className: getBlocksWith(),
    "data-auto": "more-info",
    children: [label && /*#__PURE__*/jsx("label", {
      className: getBlocksWith("__label"),
      children: label
    }), /*#__PURE__*/jsxs("div", {
      className: getBlocksWith("__info-wrapper"),
      children: [/*#__PURE__*/jsxs("div", {
        ref: infoElementRefCallback,
        style: infoElementHeight,
        className: infoClassNames,
        tabIndex: isButtonVisible ? 0 : -1,
        "aria-label": label,
        children: [children, /*#__PURE__*/jsx("div", {
          "aria-hidden": "true",
          ref: lineHeightElementRef,
          className: getBlocksWith("__hidden-element-container"),
          children: /*#__PURE__*/jsx("span", {
            className: getBlocksWith("__hidden-element"),
            children: children
          })
        })]
      }), isButtonVisible && !isExpanded && /*#__PURE__*/jsx("hr", {
        className: getBlocksWith("__gradient"),
        "data-auto": "separator",
        "aria-hidden": "true"
      }), isButtonVisible && /*#__PURE__*/jsx("div", {
        className: getBlocksWith("__button-container"),
        children: /*#__PURE__*/jsx(Button, {
          className: getBlocksWith("__button"),
          tabIndex: 0,
          onClick: handleClick,
          styleType: "link",
          children: isExpanded ? collapseButtonContent : expandButtonContent
        })
      })]
    })]
  });
});
MoreInfo.displayName = "MoreInfo";

export { MoreInfo as default };
//# sourceMappingURL=more-info-esm.js.map
